import { useContext, useEffect, useState } from "react";
import { ReactComponent as eventIcon } from '../../../../icons/event.svg';
import 'react-datepicker/dist/react-datepicker.css';
import './../poFormView.scss';
import { DatepickerFieldProps } from "../../../../components/datepickerField/types/datepickerFieldProps";
import DatepickerField from "../../../../components/datepickerField/datepickerField";
import PoFormContext from "../../../../contexts/poFormContext";
import { configValidation, createConfigValidation, validation } from "../../../../helpers/validation/validation";
import { styleFormFieldHalf } from "../../../../components/shared/stylization";

const ProtocolPrepDate = () => {
    const { poForm, setPoForm } = useContext(PoFormContext);
    const [configValidationProtocolPrepDate, setConfigValidationProtocolPrepDate] = useState<configValidation>({});
    const [errorTipText, setErrorTipText] = useState<string | null>();
    const [firstRenderMarker, setFirstRenderMarker] = useState(false);

    // Validation
    useEffect(() => {
        if (poForm.config?.check && !poForm.config.isValid) {
            var errorMsg = poForm.config?.ValidationError!["datA_PROT"]
            if (errorMsg !== '') {
                setConfigValidationProtocolPrepDate(createConfigValidation("datA_PROT", true, poForm.protocolAttributes?.datA_OBS));
                setErrorTipText(errorMsg);
            }
        }  
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [poForm.config?.check])    

    useEffect(() => {        
        if (firstRenderMarker) {
            var configValidation = createConfigValidation("datA_PROT", true, poForm.protocolAttributes?.datA_OBS);
            setConfigValidationProtocolPrepDate(configValidation);
            setErrorTipText(validation(configValidation, poForm.protocolAttributes?.datA_PROT))
        }
        if (!firstRenderMarker) setFirstRenderMarker(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps    
    }, [poForm.protocolAttributes?.datA_PROT, poForm.protocolAttributes?.datA_OBS])

    // Protocol preparation date
    const onChangeProtocolPrepDate = (event: Date) => {
        var form: any = Object.assign({}, poForm);
        if (form !== null && form.protocolAttributes) {
            event ? form.protocolAttributes.datA_PROT = event.getTime() : form.protocolAttributes.datA_PROT = null;
        }
        setPoForm(form);         
    } 

    var datepickerFieldPropsDateOfProtocolPreparation: DatepickerFieldProps = {
        dateFormat: "yyyy-MM-dd",
        selected: poForm.protocolAttributes?.datA_PROT ? new Date(new Date(poForm.protocolAttributes?.datA_PROT).setHours(0,0,0,0)) : poForm.protocolAttributes?.datA_PROT,
        shouldCloseOnSelect: false,
        fixedHeight: true,
        inputPlaceholder: "Wybierz datę",        
        labelName: 'Data sporządzenia protokołu obserwacji',
        style: styleFormFieldHalf,
        configValidation: configValidationProtocolPrepDate,
        additionalIcon: eventIcon,
        setValue: onChangeProtocolPrepDate,
        datepickerSharedProps: {
            className: 'datepicker'
        },
        validationError: errorTipText != null,
        tipText: errorTipText ? errorTipText : undefined,
        pristine: true
    }

    return (
        <>
            <div>
                <h2>8. Data sporządzenia protokołu obserwacji</h2>
                <DatepickerField {...datepickerFieldPropsDateOfProtocolPreparation}/>
            </div>
        </>
    )
}

export default ProtocolPrepDate